import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { Icon } from '../icon';
import * as Styled from './styles';
import * as SX from './sx';
import type { NoDataProps as Props } from './types';

export const NoData = memo(({ className, title, icon }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('NoData', className)}
      sx={SX.root}
      alignItems="center"
      justifyContent="center"
      gap={3}
    >
      {icon && (
        <Box sx={SX.emptyIconBox}>
          <Stack sx={SX.emptyIconWrapper}>
            <Icon name={icon} sxx={SX.emptyIcon} size={28} />
          </Stack>
        </Box>
      )}

      <Box sx={SX.noDataTitleBox}>
        <Box sx={SX.noDataTitleBox1}></Box>
        <Box sx={SX.noDataTitleBox2}></Box>
        <Stack
          sx={SX.noDataTitleWrapper}
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="body3" color="grey.500">
            {title || 'No Result Found'}
          </Typography>
        </Stack>
      </Box>
    </Styled.Wrapper>
  );
});

NoData.displayName = 'NoData';
